import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import BreakCron from "@/components/break/create/BreakCron.vue";
import moduleBreaks from "@/store/breaks/moduleBreaks.js";
import Break from "@/models/Breaks.js";
import FloatingButtons from "@/views/FloatingButtons.vue";
import {generalPurposeMixin} from "@/mixins/generalPurposeMixin.js";

export const BreakMixin = {
	name: "BreakCreate",
	mixins: [generalPurposeMixin],
	components: {
		vSelect,
		flatPickr,
		BreakCron,
		FloatingButtons,
	},
	data() {
		return {
			breakData: new Break({}),
			cronExpresion: "",
			activeNavItem: 0,
			maximize: false,
			durationProps: "12:00:00",
			showDateBreak: new Date(),
		};
	},
	created() {
		if (!moduleBreaks.isRegistered) {
			this.$store.registerModule("moduleBreaks", moduleBreaks);
			moduleBreaks.isRegistered = true;
		}
	},
	watch: {
		durationBreak(val) {
			this.durationProps = val;
		},
	},
	computed: {
		navbarTitle() {
			if (this.activeNavItem === 0) return this.$t("Crud.Create") + " " + this.$t("TimeWindow.Schedule");
			else return this.$t("VisitPoints.Add") + " " + this.$t("Vehicles.Vehicles");
		},
		validateForm() {
			return !this.errors.any();
		},
		cronExpression() {
			return this.$store.state.moduleBreaks.cronExpression;
		},
		durationBreak() {
			return `${this.hours < 10 ? "0" + this.hours : this.hours}:${
				this.minutes < 10 ? "0" + this.minutes : this.minutes
			}:${this.seconds < 10 ? "0" + this.seconds : this.seconds}`;
		},
	},
	methods: {
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		getCronExpresion(val) {
			this.cronExpresion = val;
		},
		maximizeCalendar(val) {
			this.maximize = val;
		},
		validateInputNumberMinutes(event) {
			if (this.minutes.length === 2) {
				event.preventDefault();
				return false;
			}
		},
		validateInputNumberSeconds(event) {
			if (this.seconds.length === 2) {
				event.preventDefault();
				return false;
			}
		},
		save() {
			let params = {};
			delete this.breakData.id;
			this.breakData["vehicle_id"] =
				this.$store.state.vehicle.assignedVehicles.length > 0
					? this.$store.state.vehicle.assignedVehicles.map(({id}) => id)
					: [];
			this.breakData["cron"] = this.$store.state.moduleBreaks.cronExpression;
			this.breakData["duration"] = `${this.hours < 10 ? "0" + this.hours : this.hours}:${
				this.minutes < 10 ? "0" + this.minutes : this.minutes
			}:${this.seconds < 10 ? "0" + this.seconds : this.seconds}`;
			params = {...this.breakData};
			this.$store
				.dispatch("moduleBreaks/addBreak", params)
				.then((res) => {
					this.$vs.notify({
						color: "success",
						title: this.$t("TitleConfirmBreakCreate"),
						text: this.$t("TextConfirmBreakCreate"),
					});
					this.$vs.loading.close();
					this.$router.push({name: "BreaksListView"});
					return res;
				})
				.catch((err) => {
					this.$vs.loading.close();
					this.$vs.notify({
						color: "warning",
						title: this.$t("ErrorTitle"),
						text: this.$t("ErrorMessage"),
					});
					console.error(err);
				});
		},
		submitForm() {
			this.$vs.loading();
			this.$validator.validateAll().then((result) => {
				if (result) {
					this.save();
				} else {
					this.$vs.notify({
						color: "warning",
						title: this.$t("ErrorFields.Title"),
						text: this.$t("ErrorFields.Text"),
					});
					this.$vs.loading.close();
				}
			});
		},
		getShowDate(val) {
			this.showDateBreak = val;
		},
	},
};
